module.exports = __webpack_public_path__ + "img/02yiqiyong.09c38f65.png";